import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { Routes } from '../enums/routes.enum';
import { OnboardService } from '../services/onboard.service';
import { LogService } from '../services/log.service';
import { from, map, of, switchMap, take } from 'rxjs';

export const onboardGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
	const router = inject(Router);
	const onboard = inject(OnboardService);
	const log = inject(LogService);

	const targetUrl = state.url;

	// Normalize entry to onboard flow to first step /onboard/country
	if (!targetUrl.startsWith(Routes.Onboard)) {
		return router.createUrlTree([Routes.OnboardCountry]);
	}

	// Attempt lightweight restore from sessionStorage before checks
	try {
		if (!onboard.getEmail()) {
			const persistedEmail = sessionStorage.getItem('onboard.email');
			if (persistedEmail) onboard.setEmail(persistedEmail);
		}
		if (!onboard.getOrderId()) {
			const persistedOrderId = sessionStorage.getItem('onboard.orderId');
			if (persistedOrderId) onboard.setOrderId(persistedOrderId);
		}
	} catch {}

	const email = onboard.getEmail();
	const orderId = onboard.getOrderId();

	// If we already have both, allow activation
	if (email && orderId) {
		return true;
	}

	// If no email, allow navigation to /onboard so the page can collect it
	if (!email) {
		log.debug('OnboardGuard: missing email, allowing navigation to /onboard to collect');
		return true;
	}

	// Do not fetch orderId here; allow component to handle after auth is ready
	return true;
};
